import { render, staticRenderFns } from "./ActiveOrderCustomer.vue?vue&type=template&id=2aadaf8f&"
import script from "./ActiveOrderCustomer.vue?vue&type=script&lang=js&"
export * from "./ActiveOrderCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports